import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Problems() {
  const problems = ['Subís al ataque y dejás tu banda descubierta', 'No sabés cuándo proyectarte y cuándo quedarte', 'Te ganan el duelo 1 vs 1 en defensa', 'Tus centros terminan en nada', 'Quedás mal parado en el 2 vs 1'];
  return <section className="py-16 px-4 bg-white" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl text-center text-[#1a3d1f] mb-10 uppercase" data-id="element-113">
          ¿Jugas de 3 pero no sabes como jugar de 3?
        </motion.h2>

        <div className="space-y-4" data-id="element-114">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center p-4 bg-red-50 border border-red-100 rounded-lg" data-id="element-115">
              <XCircle className="text-red-500 w-6 h-6 mr-4 flex-shrink-0" data-id="element-116" />
              <span className="text-red-700 font-medium text-lg" data-id="element-117">
                {problem}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}